/**

 * @vuelto-surface

 * mobile: ok

 * desktop: ok

 * strategy: inherit

 *

 * Footer del modal Cambiar sucursal: Nueva · Administrar.

 * Cerrar = X / backdrop (sin "Seguir en esta").

 */

import React from 'react';

import { Pressable, StyleSheet, Text, View } from 'react-native';

import { ticketColors } from '../../../shared/theme/ticketColors';



type Props = {

  onCreateBranch?: () => void;

  onManageBranches?: () => void;

};



export function BranchSelectionFooter({

  onCreateBranch,

  onManageBranches,

}: Props) {

  if (!onCreateBranch && !onManageBranches) return null;



  return (

    <View style={styles.foot} testID="auth.branch-selector.footer">

      {onCreateBranch ? (

        <Pressable

          onPress={onCreateBranch}

          style={({ pressed }) => [styles.btnPrimary, pressed && styles.pressed]}

          accessibilityRole="button"

          accessibilityLabel="Nueva sucursal"

          testID="auth.branch-selector.create"

        >

          <Text style={styles.btnPrimaryLabel}>＋ Nueva sucursal</Text>

        </Pressable>

      ) : null}

      {onManageBranches ? (

        <Pressable

          onPress={onManageBranches}

          style={({ pressed }) => [styles.btnGhost, pressed && styles.pressed]}

          accessibilityRole="button"

          accessibilityLabel="Administrar sucursales"

          testID="auth.branch-selector.manage"

        >

          <Text style={styles.btnGhostLabel}>Administrar sucursales</Text>

        </Pressable>

      ) : null}

    </View>

  );

}



const styles = StyleSheet.create({

  foot: {

    paddingHorizontal: 16,

    paddingTop: 12,

    paddingBottom: 14,

    borderTopWidth: StyleSheet.hairlineWidth,

    borderTopColor: ticketColors.ruleSoft,

    gap: 6,

    backgroundColor: ticketColors.paper,

  },

  pressed: { opacity: 0.75 },

  btnPrimary: {

    minHeight: 44,

    borderRadius: 10,

    borderWidth: 1,

    borderColor: ticketColors.gold,

    backgroundColor: ticketColors.brandSoft,

    alignItems: 'center',

    justifyContent: 'center',

    paddingHorizontal: 14,

  },

  btnPrimaryLabel: {

    fontSize: 14,

    fontWeight: '700',

    color: ticketColors.brandInk,

  },

  btnGhost: {

    minHeight: 40,

    alignItems: 'center',

    justifyContent: 'center',

    paddingHorizontal: 14,

  },

  btnGhostLabel: {

    fontSize: 13,

    fontWeight: '600',

    color: ticketColors.ink3,

  },

});


